import {DateTime} from 'luxon';

import {globalWindow} from '../../../../../libs/shared/core/src/helpers/browser/browserHelpers';
import {CompanyModel} from '../../../../../libs/shared/core/src/models/api/company/companyModel';

/*
 * Helpers.
 */

/** Formats the name and url for a CSV file to be downloaded from private API. */
export function makeCsvFileData(
  company: CompanyModel,
  decisionTreeId: number,
  startDate: DateTime,
  endDate: DateTime,
  prefix: string,
): {name: string; url: string} {
  const name = `${prefix}_${company.id}_${startDate.toISODate()}_${endDate.toISODate()}.csv`;

  const url = new URL(`${company.url}/${encodeURIComponent(prefix)}`, globalWindow.location.href);

  url.searchParams.append('decision_tree_id', decisionTreeId.toString());

  const startISO = startDate.toISODate();
  if (startISO) {
    url.searchParams.append('start_date', startISO);
  }

  const endISO = endDate.plus({days: 1}).toISODate();
  if (endISO) {
    url.searchParams.append('end_date', endISO);
  }

  return {
    name,
    url: url.toString(),
  };
}
